import functions from '../../functions';

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        RichText,
        InspectorControls,
        MediaUpload,
        InnerBlocks,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl,
        Button
    } = window.wp.components;

    registerBlockType('custom-gutenberg/card-team', {
        // built-in attributes
        title: 'Card Team',
        description: 'Custom Card Team',
        icon: '',
        category: 'custom-cards',
        example: {},

        // custom attributes
        attributes: {
            image: {
                type: 'string',
                default: ''
            }, 
            alt: {
                type: 'string',
                default: ''
            },
            name: {
                type: 'string',
                default: ''
            },
            role: {
                type: 'string',
                default: ''
            },
            description: {
                type: 'string',
                default: ''
            },
        },

        // built-in functions
        edit({ attributes, setAttributes, className }) {

            const {
                image,
                alt,
                name,
                role,
                description,
                classes
            } = attributes;

            const ALLOWED_BLOCKS = ['core/heading', 'core/paragraph'];
            const MY_TEMPLATE = [
                [ 'core/heading', { placeholder: 'Card title', className: 'card-title', level: 4 } ],
                [ 'core/heading', { placeholder: 'Card subtitle', className: 'card-subtitle', level: 6 } ],
                [ 'core/group', { className: 'card-description' }, [
                    [ 'core/paragraph', { placeholder: 'Card text' } ]
                ] ]
            ];

            className = functions.getClassNames(className);
            if(classes != className) setAttributes({classes: className});

            // custom functions
            function onSelectImage (image) {
                setAttributes({image: image.sizes.full.url});
            }

            function onAltChange(alt) {
                setAttributes({alt: alt});
            }

            function onNameChange(name) {
                setAttributes({name: name});
            }

            function onRoleChange(role) {
                setAttributes({role: role});
            }

            function onDescriptionChange(description) {
                setAttributes({description: description});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ image } 
                            render={ ( { open } ) => (
                                <div>
                                    { image && 
                                        <div>
                                            <figure>
                                                <img src={image} />
                                            </figure>
                                            <div>
                                                <Button onClick={() => setAttributes({ image: '' })} className="button">Remove</Button>
                                            </div>
                                            <br></br>
                                        </div>
                                
                                    }
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                                </div>
                            ) } />
                        <br />
                        <p><strong>Alt image:</strong></p>
                        <TextControl value={ alt } onChange={ onAltChange }></TextControl>
                        <br />
                    </PanelBody>
                </InspectorControls>
                ,
                <a className={ "card card-team" + (classes ? ' ' + classes : '') }>
                    <div class="card-img-top">
                        <img class="cover-image" src={ image } alt={ alt } />
                    </div>
                    <div class="card-body">
                        <InnerBlocks allowedBlocks={ ALLOWED_BLOCKS } template={ MY_TEMPLATE } templateLock="all" />
                    </div>
                </a>
            ]
            );
        },

        save({ attributes }) {

            const {
                link,
                image,
                alt,
                buttonText,
                classes
            } = attributes;

            return (
                <a href={ link } className={ "card card-team" + (classes ? ' ' + classes : '') }>
                    <div class="card-img-top">
                        <img class="lozad cover-image" data-src={ image } alt={ alt } />
                    </div>
                    <div class="card-body">
                        <InnerBlocks.Content />
                    </div>
                </a>
            );
        },
    });
}